import { render } from "./waiver.vue?vue&type=template&id=d9a45c68&scoped=true"
import script from "./waiver.vue?vue&type=script&lang=js"
export * from "./waiver.vue?vue&type=script&lang=js"

import "./waiver.vue?vue&type=style&index=0&id=d9a45c68&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9a45c68"]])

export default __exports__